import React from "react";
import { Box } from "@mantine/core";

const BG_URL =
  "https://daxwktpz4hkwd.cloudfront.net/vault_images/blue-haze-background.jpg";

const DEFAULTS = {
  offsetY: "-120%",
  darken: "0.85",
  hue: "0deg",
  tint: "rgba(0,0,0,0.85)",
};

type Props = React.PropsWithChildren<{}>;

const DecodeInvoiceBackground: React.FC<Props> = ({ children }) => (
  <Box
    data-decode-invoice-bg
    style={
      {
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        backgroundImage: `
          linear-gradient(
            to bottom,
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0) 60%,
            rgba(0,0,0,0.1) 85%,
            rgba(0,0,0,0.3) 100%
          ),
          radial-gradient(
            ellipse at 80% calc(var(--bg-offset-y, ${DEFAULTS.offsetY}) + 50%),
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0) 70%,
            rgba(0,0,0,0.1) 90%,
            rgba(0,0,0,0.2) 100%
          ),
          url(${BG_URL})
        `,
        backgroundSize: "100% 100%, 100% 100%, cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center, center, center",
        backgroundAttachment: "fixed",
        "--bg-offset-y": DEFAULTS.offsetY,
        "--bg-darken": DEFAULTS.darken,
        "--bg-hue": DEFAULTS.hue,
        "--bg-tint": DEFAULTS.tint,
      } as React.CSSProperties
    }
  >
    {/* overlay for color adjustments */}
    <Box
      style={{
        position: "absolute",
        inset: 0,
        backgroundColor: "var(--bg-tint)",
        mixBlendMode: "multiply",
        filter:
          "hue-rotate(var(--bg-hue)) " +
          "brightness(var(--bg-darken)) saturate(1.1)",
        pointerEvents: "none",
        zIndex: 0,
      }}
    />

    {/* content */}
    <Box style={{ position: "relative", zIndex: 1 }}>{children}</Box>
  </Box>
);

export default DecodeInvoiceBackground;
